import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder
} from '@angular/forms';
import { PtlWindowLocationService } from '@ptl/global-components';
import { PaymentManagerService } from 'src/app/angular-elements/form-wrappers/plan-enrollment-on-exchange/services/payment-manager.service';
import { PaymentPresenterService } from 'src/app/angular-elements/form-wrappers/plan-enrollment-on-exchange/services/payment-presenter.service';
import {
  OnExchangeEligibilityStateStructure,
  ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME,
  ProspectState
} from 'src/app/angular-elements/on-exchange-enrollment/reducers/eligibility.reducer';
import { EligibilityManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/eligibility-manager.service';
import { EnrollManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/enroll-manager.service';
import { PayByPhoneService } from 'src/app/angular-elements/on-exchange-enrollment/services/pay-by-phone.service';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
//import * as moment from 'moment';
import moment from 'moment';
import { DateService } from 'src/app/shared/services/date.service';
import { environment } from 'src/environments/environment';
import { OnExchangePlanAttributes } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { ON_EXCHANGE_PAYMENT_METHODS } from '../../interfaces/on-exchange-enrollment-payment-form.interface';

@Component({
    selector: 'app-confirmation-page-marketplace',
    templateUrl: './confirmation-page-marketplace.component.html',
    styleUrls: ['./confirmation-page-marketplace.component.scss'],
    standalone: false
})
export class ConfirmationPageMarketplaceComponent implements OnInit {

  amountPaid: string;
  button: string;
  ccType: string;
  chargedTo: string;
  confirmationNum: string;
  ffmNumber: string;
  monthlyPremium: string;
  paymentId: string;
  paymentMethod: string;
  printEmailAppBtn: string;
  thankYou: string;
  timeStamp: string;

  paymentTypeInfo: { label: string, value: any }[];

  constructor(
    private paymentManagerService: PaymentManagerService,
    private eligibilityManagerService: EligibilityManagerService,
    private enrollManagerService: EnrollManagerService,
    private fb: UntypedFormBuilder,
    private payByPhoneService: PayByPhoneService,
    private windowLocationService: PtlWindowLocationService,
    private reducerUtilityService: ReducerUtilityService,
    private paymentPresenterService: PaymentPresenterService,
    private dateService: DateService
  ) { }

  trackByIndex(index: number): number {
    return index;
  }

  async ngOnInit(): Promise<void> {
    const eligibilityState: OnExchangeEligibilityStateStructure = this.reducerUtilityService.getComponentStates()[
      ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME
    ];
    const matchedProspects = eligibilityState.prospects.filter(
      p => eligibilityState.currentProspectId === p.prospectId
    );

    if (matchedProspects.length > 0) {
      let prospect = matchedProspects[0];
      await this.eligibilityManagerService.get(prospect.prospectId);
      this.eligibilityManagerService.updateIndividualResponsibilityAmount(
        prospect.data.selectedPlan.price as string,
        (prospect.data.selectedPlan.attributes as OnExchangePlanAttributes).EHB
      );

      /** Just grab state again after updating it with individual responsiblity amount */
      const eStateRefresh: OnExchangeEligibilityStateStructure = this.reducerUtilityService.getComponentStates()[
        ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME
      ];
      prospect = eStateRefresh.prospects.filter(
        p => eStateRefresh.currentProspectId === p.prospectId
      )[0];

      this.setupPage(prospect);
    }
  }

  setupPage(prospect: ProspectState) {
    const paymentAmount = `$${Number(prospect.individualResponsibilityAmount).toFixed(2)}`;
    const dueDate = this.paymentPresenterService.dueDate(prospect.data.effectiveDate);
    const paymentOption = this.paymentManagerService.getPaymentOption();
    const paymentConfirmNum = this.paymentManagerService.getPaymentConfirmNum();

    const d = this.dateService.getNow();
    const currentDate = moment(d).format('MM/DD/YYYY');

    if (paymentOption === ON_EXCHANGE_PAYMENT_METHODS.CREDIT_CARD) {

      this.thankYou = 'We appreciate your business.';
      this.timeStamp = currentDate;
      // domClass.remove(button, 'hidden');
      this.button = 'PRINT PAYMENT INFORMATION';
      this.printEmailAppBtn = 'Print or Email Application';
      this.confirmationNum = paymentConfirmNum;

      const friendlyCreditCardIssuerName = (() => {
        switch (this.paymentManagerService.getPaymentData().cardInfo.ccType) {
          case 'VI':
            return 'VISA';
          case 'MC':
            return 'Master Card';
          case 'DI':
            return 'Discover';
          case 'AX':
            return 'American Express';
          default: return null;
        }
      })();

      this.paymentTypeInfo = [
        { label: 'Payment ID #', value: this.enrollManagerService.getPaymentTransactionID() },
        { label: 'Marketplace Policy Number', value: this.enrollManagerService.getFFMPolicyNumber() },
        { label: 'Monthly Premium', value: paymentAmount },
        { label: 'Amount Paid', value: paymentAmount },
        { label: `Charged to ${friendlyCreditCardIssuerName}`, value: this.paymentManagerService.maskPayment(ON_EXCHANGE_PAYMENT_METHODS.CREDIT_CARD) },
        { label: 'Expiration Date', value: this.paymentPresenterService.expirationDate() },
        { label: 'Full Name as it appears on card', value: this.paymentPresenterService.billingName() },
        { label: 'Billing Address', value: this.paymentPresenterService.billingAddress() },
      ];

      // on(button, 'click', function() {
      //   window.print();
      // });

      // on(printEmailAppBtn, 'click', function(evt) {
      //   evt.preventDefault();
      //   hmStorage.set('afterPaymentConf', true);
      //   router.go('!/marketplace/payment/options');
      // });
    } else if (paymentOption === ON_EXCHANGE_PAYMENT_METHODS.BANK_ACCOUNT) {

      this.thankYou = 'We appreciate your business.';
      this.timeStamp = currentDate;
      // domClass.remove(button, 'hidden');
      this.button = 'PRINT PAYMENT INFORMATION';
      this.printEmailAppBtn = 'Print or Email Application';
      this.confirmationNum = paymentConfirmNum;

      this.paymentTypeInfo = [
        { label: 'Payment ID #', value: this.enrollManagerService.getPaymentTransactionID() },
        { label: 'Marketplace Policy Number', value: this.enrollManagerService.getFFMPolicyNumber() },
        { label: 'Monthly Premium', value: paymentAmount },
        { label: 'Amount Paid', value: paymentAmount },
        { label: 'Charged to Bank Account', value: this.paymentManagerService.maskPayment(ON_EXCHANGE_PAYMENT_METHODS.BANK_ACCOUNT) },
        { label: 'Routing Number', value: this.paymentPresenterService.routingNumber() },
        { label: 'Primary Name on Account', value: this.paymentPresenterService.billingName() },
        { label: 'Billing Address', value: this.paymentPresenterService.billingAddress() }
      ];

      // on(button, 'click', function() {
      //   window.print();
      // });

      // on(printEmailAppBtn, 'click', function(evt) {
      //   evt.preventDefault();
      //   hmStorage.set('afterPaymentConf', true);
      //   router.go('!/marketplace/payment/options');
      // });
    } else if (paymentOption === ON_EXCHANGE_PAYMENT_METHODS.PAY_BY_PHONE) {
      this.thankYou = 'You\'re done.';
      // domConstruct.destroy(container);

      // domClass.add(button, 'hidden');
      this.printEmailAppBtn = 'Print or Email Application';

      // on(printEmailAppBtn, 'click', function(evt) {
      //   evt.preventDefault();
      //   hmStorage.set('afterPaymentConf', true);
      //   router.go('!/marketplace/payment/options');
      // });
    } else {
      this.thankYou = (() => {
        if (environment.initData.brand.ASPID === 'ND') {
          return 'You will receive a bill in the mail for your first month\'s premium. Please note: you are not covered until your effective date and payment is received.';
        } else {
          return 'A bill will be mailed to you for the amount of your first month\'s premium.';
        }
      })();

      this.timeStamp = currentDate;
      this.confirmationNum = paymentConfirmNum;
      this.paymentTypeInfo = [
        { label: 'Payment ID #', value: this.enrollManagerService.getPaymentTransactionID() },
        { label: 'Marketplace Policy Number', value: this.enrollManagerService.getFFMPolicyNumber() },
        { label: 'Monthly Premium', value: paymentAmount },
        { label: 'Payment Due Date', value: this.paymentPresenterService.dueDate(prospect.data.effectiveDate) },
        { label: 'Effective Date', value: prospect.data.effectiveDate }
      ]
      // domConstruct.destroy(container);

      // domClass.add(button, 'hidden');
      // this.printEmailAppBtn = 'Print or Email Application';

      // on(printEmailAppBtn, 'click', function(evt) {
      //   evt.preventDefault();
      //   hmStorage.set('afterPaymentConf', true);
      //   router.go('!/marketplace/payment/options');
      // });
    }
  }
}
